export default function CheckoutTutorial() {
  return (
    <section className="relative py-20 bg-[#0a1628]">
      <div className="max-w-6xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6" style={{ fontFamily: "'Roboto', sans-serif" }}>
            EXACTLY WHAT HAPPENS WHEN YOU CLICK <span className="text-[#DC2626]">"ACTIVATE"</span>
          </h2>
        </div>

        {/* Three-Panel Illustration */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {/* Panel 1 */}
          <div className="bg-gradient-to-br from-[#0f1d2e] to-[#1a2332] rounded-xl p-8 border border-[#DC2626]/20">
            <div className="w-16 h-16 bg-[#DC2626]/20 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-external-link-line text-4xl text-[#DC2626]"></i>
            </div>
            <h3 className="text-white font-black text-xl mb-4 text-center">
              You'll Land on LegalShield
            </h3>
            <p className="text-gray-300 text-lg leading-relaxed text-center">
              You'll see 2–3 plan options on their official page. Don't panic – it's simple.
            </p>
          </div>

          {/* Panel 2 */}
          <div className="bg-gradient-to-br from-[#0f1d2e] to-[#1a2332] rounded-xl p-8 border border-[#DC2626]/20">
            <div className="w-16 h-16 bg-[#DC2626]/20 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-checkbox-circle-line text-4xl text-[#DC2626]"></i>
            </div>
            <h3 className="text-white font-black text-xl mb-4 text-center">
              Choose Your Plan
            </h3>
            <p className="text-gray-300 text-lg leading-relaxed text-center">
              Pick the one I recommended in your path above. (Usually the middle option.)
            </p>
          </div>

          {/* Panel 3 */}
          <div className="bg-gradient-to-br from-[#0f1d2e] to-[#1a2332] rounded-xl p-8 border border-[#DC2626]/20">
            <div className="w-16 h-16 bg-[#DC2626]/20 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-shield-check-line text-4xl text-[#DC2626]"></i>
            </div>
            <h3 className="text-white font-black text-xl mb-4 text-center">
              You're Protected
            </h3>
            <p className="text-gray-300 text-lg leading-relaxed text-center">
              Fill in your info and pay. Coverage kicks in quickly and you'll get the app + phone number to call the firm.
            </p>
          </div>
        </div>

        {/* Summary Text */}
        <div className="max-w-3xl mx-auto text-center">
          <div className="bg-[#0f1d2e]/50 border border-[#DC2626]/20 rounded-xl p-8">
            <p className="text-gray-300 text-xl leading-relaxed mb-4">
              <strong className="text-white">You'll land on a LegalShield page with 2–3 plan options.</strong>
            </p>
            <p className="text-gray-300 text-xl leading-relaxed mb-4">
              <strong className="text-white">Choose the one I recommended in your path above.</strong>
            </p>
            <p className="text-gray-300 text-xl leading-relaxed">
              <strong className="text-white">Fill in your info and pay.</strong> Coverage kicks in quickly and you'll get the app + phone number to call the firm.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
